var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ROUTES } from 'Routes';
import { TopBackBtnBar } from 'components/navigation/TopBackBtnBar';
import { useNavigate } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { Util } from 'verid-shared-lib';
import { useMultiAuth } from 'ui-lib';
var useClasses = makeStyles({
    tableContainer: {
        marginTop: 48,
        padding: '0px 24px',
        minWidth: '850px',
        width: '100%',
    },
    table: {
        tableLayout: 'fixed',
        wordBreak: 'break-word',
    },
});
export function UserInfo() {
    var _a;
    var _b = useMultiAuth(), userState = _b.userState, $ = _b.$;
    var classes = useClasses();
    var navigate = useNavigate();
    var me = userState.me;
    var currentPersonOrg = $.currentPersonOrg();
    return (_jsxs(Grid, __assign({ container: true, justifyContent: "center" }, { children: [_jsx(TopBackBtnBar, { title: "User Info" }), _jsx(TableContainer, __assign({ component: Paper, className: classes.tableContainer }, { children: _jsxs(Table, __assign({ "aria-label": "simple table", className: classes.table }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Variable" }), _jsx(TableCell, __assign({ align: "right" }, { children: "Value" }))] }) }), _jsxs(TableBody, { children: [_jsxs(TableRow, { children: [_jsx(TableCell, __assign({ scope: "row" }, { children: "Name on Server" })), _jsx(TableCell, __assign({ align: "right" }, { children: Util.nameObjToString((_a = me === null || me === void 0 ? void 0 : me.personOrgs[0]) === null || _a === void 0 ? void 0 : _a.verificationsOf[0]) }))] }), _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ scope: "row" }, { children: "User State - ME" })), _jsx(TableCell, __assign({ align: "right" }, { children: JSON.stringify(userState.me) }))] }), _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ scope: "row" }, { children: "Current Org" })), _jsx(TableCell, __assign({ align: "right" }, { children: JSON.stringify(currentPersonOrg) }))] })] })] })) })), _jsx(Grid, __assign({ size: {
                    xs: 12,
                    sm: 6,
                } }, { children: _jsx(Box, __assign({ my: 2 }, { children: _jsx(Button, __assign({ variant: "contained", onClick: function (event) {
                            navigate(ROUTES.SERVER_INFO);
                        }, fullWidth: true }, { children: "Server Info" })) })) }))] })));
}
